import { CSSProperties, HTMLAttributeAnchorTarget, PropsWithChildren } from "react"
import { ButtonColor, ButtonSize, buttonColorSettings, buttonSizeSettings } from "./ButtonCommon";
import { classNames } from "../../../style/common";

export type AnchorButton = PropsWithChildren & {
    onClick?: () => void,
    href: string | undefined,
    target?: HTMLAttributeAnchorTarget | undefined
    className?: string,
    style?: CSSProperties | undefined,
    size?: ButtonSize,
    color?: ButtonColor
};

export function AnchorButton(props: AnchorButton) {
    const buttonColor: ButtonColor = props.color ?? "emphasis";
    const buttonSize: ButtonSize = props.size ?? "md";

    const sizeClasses = buttonSizeSettings[buttonSize];
    const colorClasses = buttonColorSettings[buttonColor];

    const getHref = () => {
        if (
            props.href?.startsWith("http://")
            || props.href?.startsWith("https://")
        ) {
            return props.href;
        }

        return `//${props.href}`;
    }

    return (
        <a
            href={getHref()}
            target={props.target}

            onClick={(event) => props.onClick ? props.onClick() : () => {}}
            style={props.style}
            className={classNames(
                sizeClasses,
                colorClasses,
                props.className
            )}
        >
            {props.children}
        </a>
    )
}